<template>
  <section class="formcta">
    <div class="formcta__content container">
      <a href="https://forms.monday.com/forms/cd7def2b1a93158b25cb8ba9d52646f2?r=use1" target="_blank">
        <button class="formcta__btn presenter-btn">{{ buttonText }}</button>
      </a>
    </div>
  </section>
</template>

<style lang="scss" scoped type="text/css">
@import "@/styles/components/formcta.scss";
</style>

<script>

export default {
  name: "generalformcta",
  props: {
    buttonText: {
      type: String,
      default: 'Register Here'
    }
  },
  data() {
    return {
      generalModal: false,
    };
  },
  methods: {
    showModal() {
      this.generalModal = true
      document.body.classList.add('modal-open');
    },
    hideModal() {
      this.generalModal = false;
      document.body.classList.remove('modal-open');
    }
  }
};
</script>
